import { ENV } from '../utils'

export class MarketAPI {
    basePath = ENV.BASE_PATH

    async getMarkets(accessToken) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.MARKETS}`;
            console.log(url)
            const params = {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };

            const response = await fetch(url, params);
            const result = await response.json()

            if(response.status !== 200) throw result;
            return result;
            
        } catch (error) {
            throw error
        }
    }
    
    //CreateMarket
    
    
    async updateMarket(accessToken, idMarket, marketData) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.MARKET}/${idMarket}`;
            const params = {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(marketData),

            }

            const response = await fetch(url, params);
            console.log( response)
            const result = await response.json();

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error
        }
    }
    
    
    //DeleteMarket   
    async deleteMarket(accessToken, idMarket) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.MARKET}/${idMarket}`;
            console.log(url)
            const params = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };
            
            const response = await fetch(url, params);
            // const result = await response.json();
            const result ={}

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    } 
     //approveMarket
     async approveMarket(accessToken, idMarket) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.MARKET}/${idMarket}${ENV.API_ROUTES.APPROVE}`
            console.log(url)
            const params = {
                method : "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }

            const response = await fetch(url, params);
           // const result = await response.json();
            const result ={}
            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    }
}